import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  // public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLoading = signal(false);
  public loadingText = signal<string | null>(null);

  showSpinner(text?: string): void {
    this.isLoading.set(true);
    if (text) {
      this.loadingText.set(text);
    }
  }

  hideSpinner(): void {
    this.isLoading.set(false);
    this.loadingText.set(null);
  }
}
